import * as React from "react";
import CommonStreamItem from "../../../hiberUiKit/src/molecules/StreamItem/CommonStreamItem";
import {TransactionActivityItemsType} from "./TransactionActivityStream";
import TransactionActivityNoteItem from "./items/TransactionActivityNoteItem";
import AccountingNote from "../../../model/invoice/note/AccountingNote";
import TransactionPaymentReceivedEvent from "../../../model/transaction/event/TransactionPaymentReceivedEvent";
import Transaction from "../../../model/transaction/Transaction";
import StripePayout from "../../../model/transaction/StripePayout";
import GoCardlessPayout from "../../../model/transaction/GoCardlessPayout";

interface ComponentProps {
	/**
	 * Transaction activity data.
	 */
	activityItems: TransactionActivityItemsType[];
	/**
	 * Note id to set active class and focus on it.
	 */
	activeNoteId: string;
	/**
	 * Transaction.
	 */
	transaction: Transaction | StripePayout | GoCardlessPayout;
	/**
	 * Edit note click action.
	 * @param note note to edit.
	 */
	onEditNoteClick: (note: AccountingNote) => void;
	/**
	 * Delete note success callback.
	 * @param note deleted note.
	 */
	onDeleteNoteSuccess: (note: AccountingNote) => void;
}

type Props = ComponentProps;

/**
 * TransactionActivityStreamItems component
 */
export default class TransactionActivityStreamItems extends React.PureComponent<Props> {
	render() {
		return this.props.activityItems.map((activity, index) => {
			return (
				<div className="c-common-details_activity-stream-item-container" key={index}>
					{this.renderItem(activity)}
				</div>
			);
		})
	}

	renderItem = (activity: TransactionActivityItemsType) => {
		if (activity instanceof AccountingNote) {
			return <TransactionActivityNoteItem activity={activity}
												isActive={this.isActive(activity.id)}
												onEditNoteClick={this.props.onEditNoteClick}
												onDeleteNoteSuccess={this.props.onDeleteNoteSuccess}/>;
		}
		if (activity instanceof TransactionPaymentReceivedEvent) {
			const creatorName = this.props.transaction instanceof Transaction ? `Via ${this.props.transaction.paymentMethod}` :
				null;
			return <CommonStreamItem event={activity} customCreatorName={creatorName}/>
		}
		return <CommonStreamItem event={activity}/>;
	};

	/**
	 * Check if note is the active one.
	 */
	isActive = (noteId: string): boolean => {
		return this.props.activeNoteId === noteId;
	};
}
